// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { CustomValidators } from '@shared/custom-validators';
import { AlertHelper } from '@shared/alert/alert.helper';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleAccessoryEntryVO } from '../../../model/vo/article-accessory-info-vo';

@Component({
  standalone: false,
  selector: 'app-edit-accessory',
  templateUrl: './edit-accessory.component.html',
})
export class EditAccessoryComponent implements OnInit {
  @Input() public accessory: ArticleAccessoryEntryVO;
  @Output() public finish = new EventEmitter<number>();

  private readonly NUMBER_RESTRICTER: string = '^[0-9]*$';

  public form: FormGroup;
  public inputValueRestricter = this.NUMBER_RESTRICTER;

  constructor(
    private bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private alertHelper: AlertHelper,
    private localeResourceManager: LocaleResourceManager
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      accessoryArticleId: new FormControl({ value: this.accessory.accessoryArticleId, disabled: true }),
      accessoryArticleNumber: new FormControl({ value: this.accessory.accessoryArticleNumber, disabled: true }),
      rotationDelta: new FormControl(this.accessory.rotationDelta.toString(), [CustomValidators.required, CustomValidators.integer]),
    });
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public save(): void {
    if (this.accessory.rotationDelta === +this.form.controls.rotationDelta.value) {
      this.alertHelper.showError('manageAccessories.error.title.rotationDelta', 'manageAccessories.error.message.rotationDelta', {
        translationParams: [this.form.controls.rotationDelta.value],
      });
      this.form.controls.rotationDelta.setErrors({});
    } else {
      this.finish.emit(+this.form.controls.rotationDelta.value);
      this.close();
    }
  }

  public getInputError(c: AbstractControl): string {
    if (c && c.hasError('messageKey')) {
      return this.localeResourceManager.getValueByKey(c.getError('messageKey'), { 0: c.getError('param') });
    } else {
      return '';
    }
  }
}
